module.exports = __webpack_public_path__ + "static/media/ktb.0a019c8f.svg";